import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import {
	Box,
	Button,
	ComposableTypography,
	Spacer,
	Typography,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { BannerCard } from '@components';
import { imagesBcp } from '@assets';
import { HeaderTag } from './headerTag';
import { rem } from '@helpers';
import { useNavigation } from '@navigation';
import { Anything } from '@types';
import { Link } from '@components';
import { useDisableIntegratedSolutionFlow, useIsOperator, useServiceResponse } from '@store';

interface resourcesIntegratedSolution {
	chipText: string;
	title: string;
	description1: string;
	description2: string;
	joinAction: string;
	knowMoreLink: string;
	knowMoreUrl: string;
}

export const IntegratedSolutionCard: React.FC = () => {
	const t = useTranslation();
	const { navigate, navigateCustomUrl } = useNavigation();
	const { retrieveContext } = useServiceResponse();
	const isOperator = useIsOperator();
	const isDisable = useDisableIntegratedSolutionFlow();

	const resources: resourcesIntegratedSolution = {
		chipText: t('placeholders.integratedSolutionBanner.chip'),
		title: t('placeholders.integratedSolutionBanner.title'),
		description1: t('placeholders.integratedSolutionBanner.description1'),
		description2: t('placeholders.integratedSolutionBanner.description2'),
		joinAction: t('placeholders.integratedSolutionBanner.actions.join'),
		knowMoreLink: t('general.knowMore'),
		knowMoreUrl: t('general.knowMore.url'),
	};

	const colorDescription = useTheme().palette.global.ui9;

	return (
		<BannerCard imageSource={imagesBcp.integratedSolutionImage}>
			<Box styles={{ width: '100%', flexDirection: 'column' }}>
				<HeaderTag text={retrieveContext?.customerInformation?.name as string} />
				<Box styles={{ marginBottom: '8px' }}>
					<Typography appearance="body-100-04">{resources.title}</Typography>
				</Box>
				<Box styles={{ flexDirection: 'column' }}>
					<Box>
						<Typography
							appearance="microcopy-100-02"
							alternativeStyleProperties={{ color: colorDescription } as Anything}
						>
							{resources.description1}
						</Typography>
					</Box>
					<Box>
						<ComposableTypography
							baseProps={{
								appearance: 'microcopy-100-02',
								alternativeStyleProperties: { color: colorDescription } as Anything,
							}}
							text={resources.description2}
							tags={{
								bold: {
									appearance: 'body-100-03',
									alternativeStyleProperties: { color: colorDescription } as Anything,
								},
								currency: {
									appearance: 'microcopy-75-03',
									alternativeStyleProperties: { color: colorDescription } as Anything,
								},
							}}
						/>
					</Box>
				</Box>
				<Spacer vertical={rem(24)} />
				<Box styles={{ alignItems: 'center' }}>
					{!isOperator && (
						<>
							<Box>
								<Button
									appearance="secondary"
									variant="light"
									size="small"
									onPress={() => navigate('integratedSolutionSelectSolution')}
									disabled={isDisable}
								>
									{resources.joinAction}
								</Button>
							</Box>
							<Spacer horizontal={rem(24)} />
						</>
					)}
					<Link
						onClick={() => {
							navigateCustomUrl(resources.knowMoreUrl);
						}}
					>
						<Typography appearance="microcopy-100-03" colorsLevel="linkDefault">
							{resources.knowMoreLink}
						</Typography>
					</Link>
				</Box>
			</Box>
		</BannerCard>
	);
};
